import {Controller, ControllerProps, useController} from "react-hook-form";

import {SliderWithRange} from "@pg-design/inputs-module";
import {ISliderWithRangeProps} from "@pg-design/inputs-module/src/types/ISliderWithRangeProps";

type IProps<FormValues extends object> = Omit<ControllerProps<FormValues>, "render" | "value"> & Omit<ISliderWithRangeProps, "onChange" | "value">;

export function SliderWithRangeControlled<FormValues extends object>(props: IProps<FormValues>) {
    const {name, defaultValue, control, ...inputProps} = props;
    const fieldController = useController<FormValues>({control, name});

    if (!fieldController) {
        throw new Error(
            "CheckboxControlled is not wrapped in FormProvider, in this case, please wrap it with FormProvider or provide an optional 'control' prop"
        );
    }

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({field}) => {
                return (
                    <SliderWithRange
                        {...field}
                        {...inputProps}
                        onChange={(_name, value) => {
                            field.onChange(value);
                        }}
                    />
                );
            }}
        />
    );
}
import {Controller, ControllerProps, useController} from "react-hook-form";

import {SliderWithRange} from "@pg-design/inputs-module";
import {ISliderWithRangeProps} from "@pg-design/inputs-module/src/types/ISliderWithRangeProps";

type IProps<FormValues extends object> = Omit<ControllerProps<FormValues>, "render" | "value"> & Omit<ISliderWithRangeProps, "onChange" | "value">;

export function SliderWithRangeControlled<FormValues extends object>(props: IProps<FormValues>) {
    const {name, defaultValue, control, ...inputProps} = props;
    const fieldController = useController<FormValues>({control, name});

    if (!fieldController) {
        throw new Error(
            "CheckboxControlled is not wrapped in FormProvider, in this case, please wrap it with FormProvider or provide an optional 'control' prop"
        );
    }

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({field}) => {
                return (
                    <SliderWithRange
                        {...field}
                        {...inputProps}
                        onChange={(_name, value) => {
                            field.onChange(value);
                        }}
                    />
                );
            }}
        />
    );
}
